import {observable, action, computed} from 'mobx';

import {VIEWS} from '../model/const';

export class VMaster {
  @observable _view;
  @observable step;
  @observable orgId; 
  @observable buId; 
  @observable trxId;
  @observable objId;

  get view() {
    return this._view;
  }

  set view(value) {
    if(value === VIEWS.root) {
      this._view = VIEWS.home;
    } else {
      this._view = value;
    }
  }

  @computed get homeActive() {
    return this.view === VIEWS.home;
  }

  @computed get searchActive() {
    return this.view === VIEWS.search;
  }

  @computed get objectDetailActive() {
    return this.view === VIEWS.objectDetails;
  }

  @computed get bwOfferDetailsActive() {
    return this.view === VIEWS.bwOfferDetails;
  }

  @computed get bwServicesActive() {
    return this.view === VIEWS.bwServices;
  }

  @computed get searchFormActive() {
    return this.homeActive || this. searchActive;
  }

  @action.bound navigate(view, step) {
    if(view) this.view = view;
    if(step) this.step = step;
  }

  @action.bound handleSceneChange(view, state) {
    this.view = view;
    this.step = state.step;

    // orgId gets bootstrapped from URL

    if(state.organizationId) this.orgId = state.organizationId;
    if(state.objectId) this.objId = state.objectId;
  }

  // Actually called ONLY when INIT
  @action.bound handleSessionStorageChange(state) {
    if(state.orgId && !this.orgId) this.orgId = state.orgId;
    if(state.objId && !this.objId) this.objId = state.objId;
    if(state.trxId && !this.trxId) this.trxId = state.trxId;
  }

  @computed get redirectSource() {
    switch(this.view) {
      case VIEWS.root:
        return {
          view: VIEWS.home,
          state: {},
        }
    }
  }
}


// WEBPACK FOOTER //
// ./src/view/VMaster.js